




































































import { Component, Prop, Vue, Model, Watch } from "vue-property-decorator";
import { AvailabilityNode } from "@/models/availability";
import DefinitionValue from "@/models/definitionValue";
import Site from "@/models/site";
import DefinitionsAPI from "@/services/definitions";
import Modal from "@/components/Modal.vue";
import AdUnit, { AdUnitFilter } from "@/models/adUnit";
import AdUnitsSelector from "@/components/AdUnitsSelector.vue";
import AdUnitsAPI from "@/services/adUnits";
import { cloneDeep } from "lodash";

@Component({ components: { Modal, AdUnitsSelector } })
export default class AvailabilityBuilder extends Vue {
  @Model("change") value?: AvailabilityNode[];
  @Prop({ default: null }) site!: Site;

  definitionValues: DefinitionValue[] = [];
  adUnits: AdUnit[] = [];
  environment: DefinitionValue = new DefinitionValue();
  layout: AvailabilityNode[] = [];
  current_node: AvailabilityNode = new AvailabilityNode();
  inputDialog = false;
  newValue = "";
  newValues: string[] = [];

  get adUnitFilters(): AdUnitFilter {
    const filter = {
      filter: {
        site_ids: this.site.id,
      },
      fields: { ad_unit: ["id", "ref", "name"].join(",") },
      page: {
        size: -1,
      },
    };
    return filter;
  }

  async created(): Promise<void> {
    await this.getDefinitionValues();
    await this.getAdUnits();

    if (this.value === null) this.buildInitialTree();
    else this.layout = cloneDeep(this.value) as AvailabilityNode[];
  }

  async getAdUnits(): Promise<void> {
    const r = await AdUnitsAPI.list(this.adUnitFilters);
    this.adUnits = r.data;
  }

  async getDefinitionValues(): Promise<void> {
    const r = await DefinitionsAPI.list(-1, -1);
    this.definitionValues = r.data;
    const environment = this.definitionValues.find(
      (d) => d.value === "environment"
    );
    environment ? (this.environment = environment) : null;
  }

  buildInitialTree(): void {
    const node = new AvailabilityNode({
      id: this.site.id as string,
      name: this.site.name,
      type: "site",
    });

    this.layout.push(node);
  }

  openDialog(node: AvailabilityNode): void {
    this.inputDialog = true;
    this.newValue = "";
    this.newValues = [];
    this.current_node = node;
  }

  addNode(): void {
    if (!this.current_node.children) {
      this.$set(this.current_node, "children", []);
    }

    if (this.newValue.length > 0) {
      const node = new AvailabilityNode();
      node.id = this.newValue.toLowerCase();
      node.name = this.newValue.toLowerCase();
      node.type = this.guessNodeType();
      this.current_node.children ? this.current_node.children.push(node) : null;
    } else {
      this.newValues.forEach((v) => {
        const node = new AvailabilityNode();
        node.id = v;
        node.name = this.getAdUnitName(v);
        node.type = this.guessNodeType();

        this.current_node.children
          ? this.current_node.children.push(node)
          : null;
      });
    }

    this.closeInputDialog();
  }

  deleteNode(node: AvailabilityNode): void {
    const tree = this.$refs.tree as any;
    const parent = tree.getParents(node.id)[0];
    if (parent) {
      node.status = "deleted";
      this.removeDeleted(this, this.layout);
    }
  }

  removeDeleted(me: any, currentArray: AvailabilityNode[]): void {
    console.log(currentArray);

    const delItems: AvailabilityNode[] = [];
    currentArray.forEach((element) => {
      if (element.status == "deleted") {
        delItems.push(element);
      }
      if (
        element.children != undefined &&
        element.children != null &&
        element.children.length > 0
      ) {
        me.removeDeleted(me, element.children);
      }
    });
    delItems.forEach((item) => {
      currentArray.splice(currentArray.indexOf(item), 1);
    });
  }

  onSelectAdUnit(v: string[]): void {
    this.newValues = v;
  }

  getAdUnitName(id: string): string {
    const adUnit = this.adUnits.find((a) => a.id === id);
    return adUnit ? adUnit.name : "";
  }

  closeInputDialog(): void {
    this.inputDialog = false;
  }

  guessNodeType(): string {
    let type = "";

    switch (this.current_node.type) {
      case "site":
        type = "section";
        break;
      case "section":
        type = "environment";
        break;
      case "environment":
        type = "group";
        break;
      case "group":
        type = "ad_unit";
        break;
    }

    return type;
  }

  getIcon(item: AvailabilityNode): string {
    let icon = "";

    switch (item.type) {
      case "site":
        icon = "mdi-web-box";
        break;
      case "section":
        icon = "mdi-view-dashboard";
        break;
      case "environment":
        icon = "mdi-view-dashboard-outline";
        break;
      case "group":
        icon = "mdi-square-rounded";
        break;
    }

    return icon;
  }

  @Watch("layout", { deep: true })
  onChange(): void {
    this.$emit("change", this.layout);
  }
}
